import { Dispatch, SetStateAction, useCallback } from "react";
import { fetchExtensions } from "../../Api/ado.api";
import useQueryWrapper from "./UseQueryWrapper";

/**
 * Hook to fetch the list of extension folders.
 * @param setError  Function to set error state in case of fetch failure.
 * @returns The list of extension folders or an empty array if none are found.
 */
export function useFetchExtensionFolders(
  setError: Dispatch<SetStateAction<string | null>>,
) {
  const func = useCallback(async () => {
    const files = await fetchExtensions();

    if (!files) {
      return [];
    }
    const filteredFolders = files.map((folder) => {
      const splitFolder = folder.path.split("/");
      return {
        ...folder,
        rootExtension: splitFolder[2] || "Unknown",
        extensionRepoPath: folder.path.replace("/Extensions/", ""),
        name: splitFolder.pop() || "Unknown",
      };
    });
    return filteredFolders;
  }, []);

  return useQueryWrapper(
    {
      queryKey: ["extensionFolders"],
      queryFn: func,
    },
    setError,
  );
}
